'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import Card from 'react-bootstrap/Card';

/**
 * Container for the facets and filters.
 */
const FacetsPanel = ({facets, headerText, showHeader = true}) => {
	let component = null;

	/*
     * This is to check and see if the facets array is not empty or containing all undefined values only.
     * If so then it indicates that there are no facets to show, in this case we display a no facets message.
     */
	if (facets && facets.join("").length === 0){
		facets = <div className="col-xs-12">No filters to apply</div>;
	}

	if (showHeader) {
		component =
			<Card role="region" aria-label="Filter Your Results" className="card-panel">
				<Card.Header>{headerText}</Card.Header>
				<Card.Body>{facets}</Card.Body>
			</Card>
	} else {
		component =
			<div>
				{facets}
			</div>
	}

	return component;
};

FacetsPanel.propTypes = {
    facets: PropTypes.array.isRequired,
	headerText: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object
	]).isRequired,
	showHeader: PropTypes.bool
};

export default FacetsPanel;
